import { render, staticRenderFns } from "./ListPrize.vue?vue&type=template&id=8020634e&"
import script from "./ListPrize.vue?vue&type=script&lang=js&"
export * from "./ListPrize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports